import styled from "styled-components";
import Button from "../../Styled/Button";
import { StyledIcon } from "../../Styled/Icon";
import Text from "../../Styled/Text";
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureInfoPanelButton = props => {
  const {
    text,
    icon
  } = props;
  if (!text) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyledButton, {
    onClick: props.onClick,
    title: props.title,
    shortMinHeight: true,
    renderIcon: icon ? () => /*#__PURE__*/_jsx(StyledIcon, {
      light: true,
      styledWidth: "20px",
      styledHeight: "20px",
      glyph: icon
    }) : undefined,
    children: text && /*#__PURE__*/_jsx(Text, {
      textLight: true,
      children: text
    })
  });
};
const StyledButton = styled(Button).attrs({
  primary: true
}).withConfig({
  displayName: "FeatureInfoPanelButton__StyledButton",
  componentId: "sc-ol74se-0"
})(["margin:0 3px;border-radius:4px;min-height:32px;"]);
export default FeatureInfoPanelButton;